// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Exercise Detail Page
   Uses shared excard-badge / excard-tag / excard-cardio from Exercise.css
   ======================================================================== */

.exdetail-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 12px 16px 80px;
}

/* ── Hero Card ─────────────────────────────────────── */
.exdetail-card {
    background: var(--surface-color, #fff);
    color: var(--text-color, #1a2b3c);
    border: 1px solid var(--border-color, transparent);
    border-radius: 16px;
    box-shadow: 0 2px 12px var(--shadow-color, rgba(8, 119, 188, 0.1));
    overflow: hidden;
    margin-bottom: 16px;
}

.exdetail-hero {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 20px 14px;
}

.exdetail-hero__img {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--text-color, #1a2b3c) 5%, var(--surface-color, #f5f8fa));
    border-radius: 14px;
    overflow: hidden;
}

.exdetail-hero__img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.exdetail-hero__info {
    flex: 1 1;
    min-width: 0;
}

.exdetail-hero__name {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color, #1a2b3c);
    margin: 0 0 8px;
    line-height: 1.3;
    word-wrap: break-word;
}

.exdetail-hero__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
}

.exdetail-hero__description {
    font-size: 13px;
    color: var(--text-secondary, #546e7a);
    line-height: 1.5;
    margin: 0 0 10px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.exdetail-hero__meta {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.exdetail-hero__duration {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-secondary, #546e7a);
}

.exdetail-hero__duration svg {
    color: var(--text-secondary, #90a4ae);
}

.exdetail-hero__state {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    background: color-mix(in srgb, #2e7d32 16%, var(--surface-color, #fff));
    color: #2e7d32;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
}

.dark-mode .exdetail-hero__state,
html[data-theme="dark"] .exdetail-hero__state {
    color: #81c784;
}

/* ── Badges rows (inside card) ─────────────────────── */
.exdetail-badges-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 20px;
    border-top: 1px solid var(--border-color, #f0f4f8);
}

.exdetail-badges-row__icon {
    font-size: 18px !important;
    margin-top: 2px;
    flex-shrink: 0;
}

.exdetail-badges-row__label {
    font-size: 12px;
    font-weight: 700;
    color: var(--text-secondary, #78909c);
    text-transform: uppercase;
    letter-spacing: 0.3px;
    min-width: 55px;
    padding-top: 3px;
    flex-shrink: 0;
}

.exdetail-badges-row__list {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    flex: 1 1;
}

/* ── Content Sections ──────────────────────────────── */
.exdetail-sections {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.exdetail-section {
    background: var(--surface-color, #fff);
    color: var(--text-color, #1a2b3c);
    border: 1px solid var(--border-color, transparent);
    border-radius: 14px;
    box-shadow: 0 1px 6px var(--shadow-color, rgba(0, 0, 0, 0.06));
    overflow: hidden;
}

.exdetail-section__header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 18px;
}

.exdetail-section__header--clickable {
    cursor: pointer;
    transition: background-color 0.15s;
}

.exdetail-section__header--clickable:hover {
    background-color: color-mix(in srgb, var(--text-color, #1a2b3c) 5%, var(--surface-color, #f8fafb));
}

.exdetail-section__icon {
    font-size: 20px !important;
    flex-shrink: 0;
}

.exdetail-section__title {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-color, #37474f);
    flex: 1 1;
}

.exdetail-section__chevron {
    font-size: 20px !important;
    color: var(--text-secondary, #90a4ae);
}

.exdetail-section__body {
    padding: 0 18px 16px;
}

.exdetail-text {
    font-size: 13px;
    color: var(--text-secondary, #546e7a);
    line-height: 1.7;
    margin: 0;
    padding: 10px 14px;
    background: color-mix(in srgb, var(--text-color, #1a2b3c) 4%, var(--surface-color, #f8fafb));
    border-radius: 10px;
    border-left: 3px solid var(--brand-primary, #0877BC);
}

.exdetail-text--focus-item {
    border-left-color: #e65100;
    margin-bottom: 6px;
}

.exdetail-text--focus-item:last-child {
    margin-bottom: 0;
}

/* ── Auto-Evaluation ───────────────────────────────── */
.exdetail-eval {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--surface-color, #fff);
    border: 1px solid var(--border-color, transparent);
    border-radius: 14px;
    box-shadow: 0 1px 6px var(--shadow-color, rgba(0, 0, 0, 0.06));
    padding: 14px 18px;
    margin-top: 16px;
}

.exdetail-eval__title {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-color, #37474f);
    margin: 0;
}

.exdetail-eval__badge {
    padding: 4px 12px;
    background: #e8f5e9;
    color: #2e7d32;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
}

/* ── Player evaluations (coach view) ───────────────── */
.exdetail-players {
    background: var(--surface-color, #fff);
    border: 1px solid var(--border-color, transparent);
    border-radius: 14px;
    box-shadow: 0 1px 6px var(--shadow-color, rgba(0, 0, 0, 0.06));
    padding: 16px 18px;
    margin-top: 16px;
}

.exdetail-players__title {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-color, #37474f);
    margin: 0 0 12px;
}

.exdetail-players__list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.exdetail-players__item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: color-mix(in srgb, var(--text-color, #1a2b3c) 4%, var(--surface-color, #f5f8fa));
    border-radius: 8px;
}

.exdetail-players__name {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-color, #37474f);
}

/* ── Responsive ─────────────────────────────────────── */
@media (max-width: 600px) {
    .exdetail-page {
        padding: 8px 8px 80px;
    }

    .exdetail-hero {
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 16px 14px 12px;
    }

    .exdetail-hero__tags {
        justify-content: center;
    }

    .exdetail-hero__meta {
        justify-content: center;
    }

    .exdetail-hero__name {
        font-size: 17px;
    }

    .exdetail-badges-row {
        flex-wrap: wrap;
        padding: 8px 14px;
    }

    .exdetail-badges-row__label {
        width: 100%;
        min-width: auto;
    }

    .exdetail-section__header {
        padding: 12px 14px;
    }

    .exdetail-section__body {
        padding: 0 14px 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/coach/ExerciseDetails.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;IACI,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA,yDAAyD;AACzD;IACI,sCAAsC;IACtC,iCAAiC;IACjC,kDAAkD;IAClD,mBAAmB;IACnB,kEAAkE;IAClE,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4FAA4F;IAC5F,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,uEAAuE;IACvE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAO;AACX;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;IACjC,kDAAkD;IAClD,mBAAmB;IACnB,8DAA8D;IAC9D,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,kGAAkG;AACtG;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,SAAO;AACX;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,4FAA4F;IAC5F,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,kDAAkD;IAClD,mBAAmB;IACnB,8DAA8D;IAC9D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,sCAAsC;IACtC,kDAAkD;IAClD,mBAAmB;IACnB,8DAA8D;IAC9D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,4FAA4F;IAC5F,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA,0DAA0D;AAC1D;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/* ========================================================================\n   Exercise Detail Page\n   Uses shared excard-badge / excard-tag / excard-cardio from Exercise.css\n   ======================================================================== */\n\n.exdetail-page {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 12px 16px 80px;\n}\n\n/* ── Hero Card ─────────────────────────────────────── */\n.exdetail-card {\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #1a2b3c);\n    border: 1px solid var(--border-color, transparent);\n    border-radius: 16px;\n    box-shadow: 0 2px 12px var(--shadow-color, rgba(8, 119, 188, 0.1));\n    overflow: hidden;\n    margin-bottom: 16px;\n}\n\n.exdetail-hero {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 20px 20px 14px;\n}\n\n.exdetail-hero__img {\n    flex-shrink: 0;\n    width: 64px;\n    height: 64px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: color-mix(in srgb, var(--text-color, #1a2b3c) 5%, var(--surface-color, #f5f8fa));\n    border-radius: 14px;\n    overflow: hidden;\n}\n\n.exdetail-hero__img img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.exdetail-hero__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.exdetail-hero__name {\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-color, #1a2b3c);\n    margin: 0 0 8px;\n    line-height: 1.3;\n    word-wrap: break-word;\n}\n\n.exdetail-hero__tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 10px;\n}\n\n.exdetail-hero__description {\n    font-size: 13px;\n    color: var(--text-secondary, #546e7a);\n    line-height: 1.5;\n    margin: 0 0 10px;\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.exdetail-hero__meta {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exdetail-hero__duration {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-secondary, #546e7a);\n}\n\n.exdetail-hero__duration svg {\n    color: var(--text-secondary, #90a4ae);\n}\n\n.exdetail-hero__state {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 10px;\n    background: color-mix(in srgb, #2e7d32 16%, var(--surface-color, #fff));\n    color: #2e7d32;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.dark-mode .exdetail-hero__state,\nhtml[data-theme=\"dark\"] .exdetail-hero__state {\n    color: #81c784;\n}\n\n/* ── Badges rows (inside card) ─────────────────────── */\n.exdetail-badges-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 10px 20px;\n    border-top: 1px solid var(--border-color, #f0f4f8);\n}\n\n.exdetail-badges-row__icon {\n    font-size: 18px !important;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.exdetail-badges-row__label {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--text-secondary, #78909c);\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    min-width: 55px;\n    padding-top: 3px;\n    flex-shrink: 0;\n}\n\n.exdetail-badges-row__list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    flex: 1;\n}\n\n/* ── Content Sections ──────────────────────────────── */\n.exdetail-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.exdetail-section {\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #1a2b3c);\n    border: 1px solid var(--border-color, transparent);\n    border-radius: 14px;\n    box-shadow: 0 1px 6px var(--shadow-color, rgba(0, 0, 0, 0.06));\n    overflow: hidden;\n}\n\n.exdetail-section__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 14px 18px;\n}\n\n.exdetail-section__header--clickable {\n    cursor: pointer;\n    transition: background-color 0.15s;\n}\n\n.exdetail-section__header--clickable:hover {\n    background-color: color-mix(in srgb, var(--text-color, #1a2b3c) 5%, var(--surface-color, #f8fafb));\n}\n\n.exdetail-section__icon {\n    font-size: 20px !important;\n    flex-shrink: 0;\n}\n\n.exdetail-section__title {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--text-color, #37474f);\n    flex: 1;\n}\n\n.exdetail-section__chevron {\n    font-size: 20px !important;\n    color: var(--text-secondary, #90a4ae);\n}\n\n.exdetail-section__body {\n    padding: 0 18px 16px;\n}\n\n.exdetail-text {\n    font-size: 13px;\n    color: var(--text-secondary, #546e7a);\n    line-height: 1.7;\n    margin: 0;\n    padding: 10px 14px;\n    background: color-mix(in srgb, var(--text-color, #1a2b3c) 4%, var(--surface-color, #f8fafb));\n    border-radius: 10px;\n    border-left: 3px solid var(--brand-primary, #0877BC);\n}\n\n.exdetail-text--focus-item {\n    border-left-color: #e65100;\n    margin-bottom: 6px;\n}\n\n.exdetail-text--focus-item:last-child {\n    margin-bottom: 0;\n}\n\n/* ── Auto-Evaluation ───────────────────────────────── */\n.exdetail-eval {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: var(--surface-color, #fff);\n    border: 1px solid var(--border-color, transparent);\n    border-radius: 14px;\n    box-shadow: 0 1px 6px var(--shadow-color, rgba(0, 0, 0, 0.06));\n    padding: 14px 18px;\n    margin-top: 16px;\n}\n\n.exdetail-eval__title {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--text-color, #37474f);\n    margin: 0;\n}\n\n.exdetail-eval__badge {\n    padding: 4px 12px;\n    background: #e8f5e9;\n    color: #2e7d32;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n/* ── Player evaluations (coach view) ───────────────── */\n.exdetail-players {\n    background: var(--surface-color, #fff);\n    border: 1px solid var(--border-color, transparent);\n    border-radius: 14px;\n    box-shadow: 0 1px 6px var(--shadow-color, rgba(0, 0, 0, 0.06));\n    padding: 16px 18px;\n    margin-top: 16px;\n}\n\n.exdetail-players__title {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--text-color, #37474f);\n    margin: 0 0 12px;\n}\n\n.exdetail-players__list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.exdetail-players__item {\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    background: color-mix(in srgb, var(--text-color, #1a2b3c) 4%, var(--surface-color, #f5f8fa));\n    border-radius: 8px;\n}\n\n.exdetail-players__name {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-color, #37474f);\n}\n\n/* ── Responsive ─────────────────────────────────────── */\n@media (max-width: 600px) {\n    .exdetail-page {\n        padding: 8px 8px 80px;\n    }\n\n    .exdetail-hero {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        padding: 16px 14px 12px;\n    }\n\n    .exdetail-hero__tags {\n        justify-content: center;\n    }\n\n    .exdetail-hero__meta {\n        justify-content: center;\n    }\n\n    .exdetail-hero__name {\n        font-size: 17px;\n    }\n\n    .exdetail-badges-row {\n        flex-wrap: wrap;\n        padding: 8px 14px;\n    }\n\n    .exdetail-badges-row__label {\n        width: 100%;\n        min-width: auto;\n    }\n\n    .exdetail-section__header {\n        padding: 12px 14px;\n    }\n\n    .exdetail-section__body {\n        padding: 0 14px 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
